export default {"src":"/_next/static/media/house_with_key_64.d37eae0e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};